<template>
   <transition name="modal">
        <div id="addUserToTalkgroup" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="addUser" v-t="'message.title_add_user_to_group'">
                    </div>
                    <div v-else v-t="'message.title_edit_user_to_group'">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <MultiSelection
                        :appData="appData"
                        :title="selectedTitle"
                        :forbidAllDelete="false"
                        :talkgroupAttribute="talkgroupAttribute"
                        :operationMode="3"
                        :selectionMultiType="[OBJECT_USER, OBJECT_IP_RADIO]"
                        @changeSelectedUser="handleChangeSelectedUser()"
                        ref="MultiSelection">
                    </MultiSelection>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import MultiSelection from "./MultiSelection.vue"

export default {
    data() {
      return {
          disableSave: true,
          selectedTitle: commonUtil.getMessageText(this.$i18n,"title_groupUser")
      };
    },
    computed: {
        OBJECT_USER: () => { return constants.OBJECT_USER; },
        OBJECT_IP_RADIO: () => { return constants.OBJECT_IP_RADIO; },
    },
    methods: {
        handleChangeSelectedUser() {
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('update' , {removeTagList: this.$refs.MultiSelection.removeTagList , addTagList: this.$refs.MultiSelection.addTagList});
        },
    },
    components: {
        MultiSelection,
    },
    created: function() {
        this.disableSave = true;
    },
    props: ['appData' , 'talkgroupAttribute' , 'addUser' ]
}
</script>


<style scoped>
.dialoginputfield {
    height: 60px;
}

.findedUser-record {
  cursor: pointer;
}
.findedUser-record:hover {
  background-color: #ecf1fa;
}

.findedUser {
  padding: 10px 20px;
}

.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}
.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}

.el-input-group {
    width: 650px;
    padding-left: 20px;
    padding-bottom: 0;
}

.el-select-dropdown__item.selected {
    color: #000000;
}

.el-select-dropdown__item {
    font-size: 14px;
}

</style>
